// 登陆页
export const GET_COUNTRY_INFO = 'GET_COUNTRY_INFO';

